import * as env from '@/common/environment';
import { useCustomisationStore } from '@/common/customisation/stores/customisation.store';
import { getThemeField, THEME_DEFAULT_USER_NAME_FIELD_PARAMS } from '@/common/customisation/utils/themeField';
import { useI18n } from '@/plugins/i18n';

const getEnvUserName = (): string => {
  return `${env.get('default')?.userName || ''}`.trim();
};

export const getFallbackUserName = (): string => {
  const envUserName = getEnvUserName();
  if (envUserName) return envUserName;

  let themeUserName = '';
  try {
    const customisationStore = useCustomisationStore();
    const raw = getThemeField<string>(customisationStore, THEME_DEFAULT_USER_NAME_FIELD_PARAMS);
    themeUserName = typeof raw === 'string' ? raw.trim() : '';
  } catch {
    themeUserName = '';
  }
  if (themeUserName) return themeUserName;

  return useI18n().t('global.user', 'User');
};
